<template>
    <v-container class="fill-height" style="display: block;" fluid v-if="show">
        <v-tabs v-model="tab" color="#ffffff">
            <v-tabs-slider color="#ffffff"></v-tabs-slider>
            <v-tab style="width: 60px; min-width: 60px;" key="general"><v-icon color="#FFD700">mdi-database</v-icon></v-tab>
            <v-tab key="connections">Connections</v-tab>
            <v-tab key="tables">Tables</v-tab>
            <v-tab key="indexes">Indexes</v-tab>
            <v-tab key="roles">Roles</v-tab>
            <v-tab key="config">Config</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="tab-content-full-height">
            <v-tab-item key="general">
                <v-row class="d-flex">
                    <v-col class="fixed-width" style="width: 280px; max-width: 280px; padding-top: 0px;">
                        <div style="padding-top: -10px; position: relative;">
                            <v-icon style="font-size: 260px;" x-large color="grey">mdi-database</v-icon>
                            <span class="db-size">{{ prettyFs(dbSummary.size_of_database.database_size) }}</span>
                        </div>
                        
                    </v-col>
                    <v-col class="flex-grow-1">
                        <div style="padding-top: 26px;">
                            <div><span class="info-label">Version: </span><span>{{ dbSummary.pg_version.version }}</span></div>
                            <div><span class="info-label">Host: </span><span>{{ dbSummary.connection_info.host || '' }}</span></div>
                            <div><span class="info-label">Port: </span><span>{{ dbSummary.connection_info.port || '' }}</span></div>
                            <div><span class="info-label">DB Name: </span><span>{{ dbSummary.connection_info.dbname || '' }}</span></div>
                            <div><span class="info-label">User: </span><span>{{ dbSummary.connection_info.user || '' }}</span></div>
                            <div><span class="info-label">Password: </span><span>{{ dbSummary.connection_info.password || '' }}</span></div>
                            <div><span class="info-label">Application Name: </span><span>{{ dbSummary.connection_info.application_name || '' }}</span></div>
                            <!-- <br>
                            <div><span class="info-label">Number of Tables: </span><span>{{ dbSummary.size_of_tables.length }}</span></div> -->
                            <div style="text-align: left; margin-top: 5px;">
                                <v-btn color="blue" @click="getConfig">Refresh</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item key="connections">
                <v-data-table :headers="connectionsHeaders" :items="dbSummary.active_connections" :items-per-page="-1" :search="connectionsSearch" class="elevation-1" hide-default-footer fixed-header height="calc(100vh - 210px)">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title style="color: #ffffff; font-weight: bold;">Active Connections</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-text-field color="#c42111" class="" v-model="connectionsSearch" append-icon="mdi-magnify" label="Search Connections" single-line hide-details></v-text-field>
                            <v-spacer></v-spacer>
                            <v-btn color="blue" min-width="40" width="40" @click="getConnections"><v-icon>mdi-refresh</v-icon></v-btn>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.connection_state="{ item }">
                        <v-chip small pill outlined color="green" v-if="item.connection_state == 'active'">active</v-chip>
                        <v-chip small pill outlined color="orange" v-else-if="item.connection_state == 'idle'">idle</v-chip>
                        <span v-else>{{item.connection_state}}</span>
                    </template>
                </v-data-table>
            </v-tab-item>

            <v-tab-item key="tables">
                <v-data-table :headers="tablesHeaders" :items="dbSummary.size_of_tables" :items-per-page="-1" :search="tablesSearch" class="elevation-1" hide-default-footer fixed-header height="calc(100vh - 210px)">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title style="color: #ffffff; font-weight: bold;">Tables</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-text-field color="#c42111" class="" v-model="tablesSearch" append-icon="mdi-magnify" label="Search Table Name" single-line hide-details></v-text-field>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.size_bytes="{ item }">
                        {{ prettyFs(item.size_bytes) }}
                    </template>
                </v-data-table>
            </v-tab-item>

            <v-tab-item key="indexes">
                <v-data-table :headers="indexesHeaders" :items="dbSummary.index_usage" :items-per-page="-1" :search="indexesSearch" class="elevation-1" hide-default-footer fixed-header height="calc(100vh - 210px)">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title style="color: #ffffff; font-weight: bold;">Indexes</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-text-field color="#c42111" class="" v-model="indexesSearch" append-icon="mdi-magnify" label="Search Index Name" single-line hide-details></v-text-field>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.index_size="{ item }">
                        {{ prettyFs(item.index_size) }}
                    </template>
                </v-data-table>
            </v-tab-item>

            <v-tab-item key="roles">
                <v-data-table :headers="rolesHeaders" :items="dbSummary.roles_and_permissions" :items-per-page="-1" :search="rolesSearch" class="elevation-1" hide-default-footer fixed-header height="calc(100vh - 210px)">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title style="color: #ffffff; font-weight: bold;">Roles</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-text-field color="#c42111" class="" v-model="rolesSearch" append-icon="mdi-magnify" label="Search Role Name" single-line hide-details></v-text-field>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.is_superuser="{ item }">
                        <v-icon color="green" v-if="item.is_superuser == 't'">mdi-check</v-icon>
                        <v-icon color="red" v-if="item.is_superuser == 'f'">mdi-close</v-icon>
                    </template>
                    <template v-slot:item.can_create_role="{ item }">
                        <v-icon color="green" v-if="item.can_create_role == 't'">mdi-check</v-icon>
                        <v-icon color="red" v-if="item.can_create_role == 'f'">mdi-close</v-icon>
                    </template>
                    <template v-slot:item.can_create_db="{ item }">
                        <v-icon color="green" v-if="item.can_create_db == 't'">mdi-check</v-icon>
                        <v-icon color="red" v-if="item.can_create_db == 'f'">mdi-close</v-icon>
                    </template>
                </v-data-table>
            </v-tab-item>

            <v-tab-item key="config">
                <v-data-table :headers="configHeaders" :items="dbSummary.db_config_settings" :items-per-page="-1" :search="configSearch" class="elevation-1" hide-default-footer fixed-header height="calc(100vh - 210px)">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title style="color: #ffffff; font-weight: bold;">Settings</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-text-field color="#c42111" class="" v-model="configSearch" append-icon="mdi-magnify" label="Search Setting Name" single-line hide-details></v-text-field>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.table_size="{ item }">
                        {{ prettyFs(item.table_size) }}
                    </template>
                </v-data-table>
            </v-tab-item>
        </v-tabs-items>
        
    </v-container>
</template>

<script>
export default {
    name: 'DatabaseInfo',
    props: [],
    components: {

    },
    data: () => ({
        show: false,
        tab: 0,
        dbSummary: null,

        connectionsHeaders: [
            {text: 'PID', align: 'start', filterable: false, sortable: true, value: 'process_id'},
            {text: 'Database Name', align: 'start', filterable: true, sortable: true, value: 'database_name'},
            {text: 'Application Name', align: 'start', filterable: true, sortable: true, value: 'application_name'},
            {text: 'Connection State', align: 'center', filterable: false, sortable: true, value: 'connection_state'},
            {text: 'User Name', align: 'start', filterable: true, sortable: true, value: 'user_name'},
            {text: 'Client Address', align: 'center', filterable: false, sortable: true, value: 'client_address'},
            {text: 'Client Port', align: 'center', filterable: false, sortable: true, value: 'client_port'},
            {text: 'Backend Start Time', align: 'center', filterable: false, sortable: true, value: 'backend_start_time'},
            {text: 'Current Query', align: 'start', filterable: false, sortable: true, value: 'current_query'},
        ],
        connectionsSearch: "",

        tablesHeaders: [
            {text: 'Schema Name', align: 'start', filterable: true, sortable: true, value: 'schema_name'},
            {text: 'Table Name', align: 'start', filterable: true, sortable: true, value: 'table_name'},
            {text: 'Columns', align: 'center', filterable: false, sortable: true, value: 'num_columns'},
            {text: 'Rows', align: 'center', filterable: false, sortable: true, value: 'num_rows'},
            {text: 'Size', align: 'center', filterable: false, sortable: true, value: 'size_bytes'}
        ],
        tablesSearch: "",

        indexesHeaders: [
            {text: 'Index Name', align: 'start', filterable: true, sortable: true, value: 'index_name'},
            {text: 'Size', align: 'center', filterable: false, sortable: true, value: 'index_size'}
        ],
        indexesSearch: "",

        rolesHeaders: [
            {text: 'Role Name', align: 'start', filterable: true, sortable: true, value: 'role_name'},
            {text: 'is_superuser', align: 'center', filterable: false, sortable: true, value: 'is_superuser'},
            {text: 'can_create_role', align: 'center', filterable: false, sortable: true, value: 'can_create_role'},
            {text: 'can_create_db', align: 'center', filterable: false, sortable: true, value: 'can_create_db'},
        ],
        rolesSearch: "",

        configHeaders: [
            {text: 'Setting Name', align: 'start', filterable: true, sortable: true, value: 'name'},
            {text: 'Setting Description', align: 'start', filterable: true, sortable: true, value: 'description'},
            {text: 'Size', align: 'center', filterable: false, sortable: true, value: 'setting'}
        ],
        configSearch: "",
    }),

    computed: {
        generalData() {
            return [{
                pg_version: this.dbSummary.pg_version.version,
                database_size: this.dbSummary.size_of_database.database_size,
                num_of_tables: this.dbSummary.size_of_tables.length   
            }];
        }

    },

    methods: {
        getConfig: function() {
            console.log('GET SUMMARY');
            TELSA.loading(true);
            let route = (TELSA.apiHost + "databaseinfo/summary");
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result);
                this.dbSummary = result;
                TELSA.loading(false);
                this.show = true;
            });
        },

        getConnections: function() {
            let route = (TELSA.apiHost + "databaseinfo/connections");
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result);
                this.dbSummary.active_connections = result;
            });
        },

        prettyFs: function(bytes) {
            return TELSA.readableFileSize(bytes);
        },
    },

    mounted() {
        this.getConfig();
    }

  
};
</script>

<style scoped>

    .tab-content-full-height {
        /* height: calc(100% - 56px); */
        /* height: calc(100% - 88px); */
        /* height: calc(100vh - 138px); */
        padding: 10px;
        position: relative;
        border: #575757 solid 1px;
        border-top: none;
        background-color: #303030;;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);

        /* overflow: auto; */
    }

    .db-size {
        display: block;
        font-size: 20px;
        /* color: #303030; */
        color: #333333;
        font-weight: bold;
        width: 100px;
        text-align: center;
        position: absolute;
        top: 55px;
        left: calc(50% - (100px / 2));
    }

    .info-label {
        color: #2196F3;
        font-weight: bold;
    }

</style>

<style>

    .tab-content-full-height .v-window__container {
        /* height: 100%; */
    }

    .tab-content-full-height .v-window-item.v-window-item--active {
        /* height: 100%; */
    }

</style>
